import { useEffect } from "react";

export function useAsyncEffect(asyncFn, deps) {
  useEffect(() => {
    asyncFn().catch(console.error);
  }, deps);
}

export default useAsyncEffect;
